import { render, staticRenderFns } from "./TabContainer.vue?vue&type=template&id=485802fc&scoped=true&"
import script from "./TabContainer.vue?vue&type=script&lang=ts&"
export * from "./TabContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TabContainer.vue?vue&type=style&index=0&id=485802fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485802fc",
  null
  
)

export default component.exports